(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-drawer')) {
    class NcDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-drawer-close]')) this.close();
        });
        this.dialog.addEventListener('close', () =>
          this.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true })),
        );
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }
    }

    customElements.define('nc-drawer', NcDrawer);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-drawer-open]');
      if (!trigger) return;
      const drawer = document.getElementById(trigger.dataset.drawerOpen);
      if (drawer && typeof drawer.open === 'function') drawer.open();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-localization-form')) {
    customElements.define(
      'nc-localization-form',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', () => this.closest('form')?.submit());
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-quick-add')) {
    customElements.define(
      'nc-quick-add',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.onClick.bind(this));
        }

        onClick(event) {
          const addTrigger = event.target.closest('[data-quick-add]');
          const viewTrigger = event.target.closest('[data-quick-view]');
          if (addTrigger) {
            event.preventDefault();
            if (this.dataset.singleVariant !== undefined) this.addToCart(addTrigger);
            else this.openDialog();
          } else if (viewTrigger) {
            event.preventDefault();
            this.openDialog();
          }
        }

        openDialog() {
          const dialog = document.getElementById('quick-add');
          if (dialog && typeof dialog.open === 'function') dialog.open(this.dataset.productUrl);
        }

        async addToCart(trigger) {
          trigger.setAttribute('aria-busy', 'true');

          const formData = new FormData();
          formData.append('id', this.dataset.variantId);
          formData.append('quantity', '1');
          formData.append('sections', 'cart-drawer');

          try {
            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: formData,
            });
            if (!response.ok) throw new Error('cart add failed');
            const data = await response.json();

            const cart = await fetch(this.dataset.cartUrl).then((res) => res.json());
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, sections: data.sections } }));
            document.dispatchEvent(new CustomEvent('cart:open'));
          } catch (error) {
            window.location.href = trigger.href;
          } finally {
            trigger.removeAttribute('aria-busy');
          }
        }
      },
    );
  }

  if (!customElements.get('nc-wishlist-button')) {
    customElements.define(
      'nc-wishlist-button',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.button) return;
          this.button.hidden = false;
          this.button.addEventListener('click', this.toggle.bind(this));
          this.onUpdate = this.sync.bind(this);
          document.addEventListener('wishlist:updated', this.onUpdate);
          this.sync();
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:updated', this.onUpdate);
        }

        read() {
          try {
            const list = JSON.parse(localStorage.getItem('nc:wishlist'));
            return Array.isArray(list) ? list : [];
          } catch (error) {
            return [];
          }
        }

        sync() {
          const active = this.read().includes(this.dataset.handle);
          this.button.classList.toggle('is-active', active);
          this.button.setAttribute('aria-pressed', String(active));
          this.button.setAttribute('aria-label', active ? this.dataset.labelRemove : this.dataset.labelAdd);
        }

        toggle(event) {
          event.preventDefault();
          const handle = this.dataset.handle;
          const list = this.read();
          const next = list.includes(handle) ? list.filter((item) => item !== handle) : [...list, handle];
          try {
            localStorage.setItem('nc:wishlist', JSON.stringify(next));
          } catch (error) {
            return;
          }
          document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
            el.textContent = next.length;
            el.hidden = next.length === 0;
          });
          document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: next } }));
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-quantity')) {
    class NcQuantity extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-quantity-step]');
          if (button && !button.disabled) this.step(Number(button.dataset.quantityStep));
        });
        this.input.addEventListener('change', () => this.update());
        this.update();
      }

      step(direction) {
        const { input } = this;
        const min = input.min === '' ? 1 : Number(input.min);
        const max = input.max === '' ? Infinity : Number(input.max);
        const next = Math.min(max, Math.max(min, (Number(input.value) || min) + direction));
        if (String(next) === input.value) return;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      update() {
        const { input } = this;
        const min = input.min === '' ? 1 : Number(input.min);
        const max = input.max === '' ? Infinity : Number(input.max);
        const value = Number(input.value) || min;
        const [minus, plus] = this.querySelectorAll('[data-quantity-step]');
        minus.disabled = value <= min;
        plus.disabled = value >= max;
      }
    }

    customElements.define('nc-quantity', NcQuantity);
  }
  } catch(e) { console.error(e); }
})();

})();
